import { useLoaderData } from '@remix-run/react'
import { useState } from 'react'
import { PickupInPoint } from './ShippingPickup'
import ShippingScheduleSelected from './ShippingPickup/PickupSelectedCard'
import { Badge, Card, CardContainer } from '~/design-system/primitives'
import { Storefront } from '~/icons'
import type { loader } from '~/routes/checkout.cart'

export type ShippingSchedulelProps = {}

export default function ShippingSchedule(_props: ShippingSchedulelProps) {
  const { shippingData } = useLoaderData<typeof loader>()
  const { selectedSlaPickup } = useLoaderData<typeof loader>()
  const [isShippingScheduleModalOpen, setIsShippingScheduleModalOpen] = useState<boolean>(false)

  return (
    <Card color="primary" size="full" border>
      <CardContainer>
        <div className="flex items-center gap-2">
          <Storefront className="fill-gray-100 text-lg" />

          <h2 className="flex flex-wrap text-sm">
            Retirada&nbsp;<span className=" text-primary-success">grátis</span>&nbsp;na loja
          </h2>
        </div>
        <Badge color="success" size="small">
          R$ 0,00
        </Badge>
      </CardContainer>
      {shippingData.selectDeliveryChannel.type === 'pickup-in-point' &&
        !isShippingScheduleModalOpen &&
        !!selectedSlaPickup ? (
        <ShippingScheduleSelected openShippingScheduleModal={() => setIsShippingScheduleModalOpen(true)} />
      ) : (
        <PickupInPoint
          isShippingScheduleModalOpen={isShippingScheduleModalOpen}
          setIsShippingScheduleModalOpen={setIsShippingScheduleModalOpen}
        />
      )}
    </Card>
  )
}
